// The Forecasts panel's search: a forecast matches when its title holds every typed word (any
// order, any case, anywhere in a word, so "fed" finds "Federal"). Pure.
import { forecastDisplayName } from "./displayName.js";

/** The typed words, lower case; none for blank input. */
export function searchWords(query) {
  return String(query || "")
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
}

/** Does forecast `f` match every word in `words`? Matches its shown title and its question. */
export function matchesTitle(f, words) {
  if (!words.length) return true;
  const hay = [forecastDisplayName(f), f?.question, f?.contract?.question, f?.contract?.title]
    .filter((s) => typeof s === "string")
    .join(" ")
    .toLowerCase();
  return words.every((w) => hay.includes(w));
}
